import { render, staticRenderFns } from "./BusinessStatistics.vue?vue&type=template&id=3089c9e0&"
import script from "./BusinessStatistics.vue?vue&type=script&lang=ts&"
export * from "./BusinessStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports